module.exports = __webpack_public_path__ + "img/logo.57b29731.png";